import React, { useRef } from "react";
import { FormPopUp } from "../FormPopUp/FormPopUp";
import emailjs from "@emailjs/browser";
import styles from "./Form.module.css";
import { Button } from "../Buttons/Button/Button";

function Form({ position, title, initialMessage, messageLabel }) {
  const form = useRef();
  const [name, setName] = React.useState("");
  const [mail, setMail] = React.useState("");
  const [message, setMessage] = React.useState(initialMessage);
  const [popUp, setPopUp] = React.useState(false);
  const [popUpError, setPopUpError] = React.useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_tqx33tn",
        "template_fs12fzs",
        form.current,
        "xYgarc9zPHWHHp98N"
      )
      .then(
        (result) => {
          setName("");
          setMail("");
          setMessage("");
          setPopUp(true);
        },
        (error) => {
          setName("");
          setMail("");
          setMessage("");
          setPopUpError(true);
        }
      );
  };

  return (
    <div className={styles.container} style={position}>
      {popUp && (
        <FormPopUp
          message="Gracias por tu mensaje 🥳"
          button="Continuar"
          onClose={setPopUp}
        ></FormPopUp>
      )}

      {popUpError && (
        <FormPopUp
          message="¡Uy! Algo salió mal 😅"
          button="Intentar de nuevo"
          onClose={setPopUpError}
        ></FormPopUp>
      )}
      <h3 className={styles.title}>{title}</h3>
      <form onSubmit={sendEmail} ref={form}>
        <label htmlFor="name-input">Tu nombre</label>
        <input
          required
          type="text"
          id="name-input"
          value={name}
          name="user_name"
          onChange={(event) => setName(event.target.value)}
        ></input>
        <label htmlFor="mail-input">Tu mail</label>
        <input
          required
          type="text"
          id="mail-input"
          value={mail}
          name="user_mail"
          onChange={(event) => setMail(event.target.value)}
        ></input>
        <label htmlFor="message-input">{messageLabel}</label>
        <textarea
          required
          type="text"
          id="message-input"
          value={message}
          name="message"
          onChange={(event) => setMessage(event.target.value)}
        ></textarea>
        <Button type="submit">Enviar</Button>
      </form>
    </div>
  );
}

export { Form };
